module.exports = __webpack_public_path__ + "static/media/si_7.b25d78e6.JPG";